import React, {Component} from 'react';
import styles from "./detail.module.css";
import {FILE_URL} from "../../../util/constants";
import back from "../../../img/ic_back.png";


const Detail = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.onRequestClose}/>
            <div className={styles["modal-title"]}>活动详情</div>
        </div>

        <div className={styles.container}>
            <div className={styles['container-top']}>
                <img className={styles['top-img']} src={props.huodong_img}/>
                <div>
                    <div className={styles["top-title"]}>{props.huodong_info.title}</div>
                    <div
                        className={styles["text-num"]}>{props.huodong_info.taolun_num}讨论 {props.huodong_info.user_num}参与
                    </div>
                </div>
            </div>

            <div className={styles['container-bottom']}>
                <div className={styles["list-suyang"]}>
                    {
                        props.huodong_suyang.map((item, index) => {
                            return (
                                <div className={styles["suyang-item"]}>
                                    <div
                                        className={props.suyang_code == item.code ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                                        onClick={props.clickSuyuan.bind(null, item.code, index)}>
                                        {item.name}
                                    </div>
                                </div>);
                        })
                    }
                </div>

                <div className={styles.list}>
                    {
                        props.tianyuanList.length > 0 ? (
                                <React.Fragment>
                                    {
                                        props.tianyuanList.map((item, index, array) => {
                                            return (
                                                <div className={styles['list-item']}>
                                                    <div className={styles['list-item-top']} onClick={props.chakanDongtai.bind(null,item.tianyuanid)}>
                                                        <img
                                                            className={styles['list-item-touxiang']}
                                                            src={item.teacher_img}
                                                            onError={props.handleImageErrored.bind(this, index)}
                                                        />
                                                        <div className={styles['div-name']}>
                                                            <div className={styles['item-name']}>{item.teacher_name}</div>
                                                            <div className={styles['item-date']}>{item.time}</div>
                                                        </div>
                                                    </div>
                                                    <div className={styles['list-item-bottom']}>

                                                        <div className={styles["div-content"]} onClick={props.chakanDongtai.bind(null,item.tianyuanid)}>
                                                            {item.content}
                                                        </div>

                                                        <div className={styles["container-photo"]} onClick={props.chakanDongtai.bind(null,item.tianyuanid)}>
                                                            {item.img.map((item0, index0, array) => {
                                                                return (
                                                                    <img className={item.img.length>1?styles.photo:styles.photo2} src={item0.img}
                                                                         onError={props.handleImageErrored2.bind(this,index, index0)}
                                                                    />
                                                                )
                                                            })
                                                            }
                                                        </div>


                                                        <div className={styles["container-bt"]}>
                                                            <div className={item.status=='3'?styles["bt-green"]:styles["bt-gray"]} onClick={props.checkNo.bind(null,item.tianyuanid,item.status)}>审核不通过</div>
                                                            <div className={item.status=='1'?styles["bt-green"]:styles["bt-gray"]} onClick={props.checkYes.bind(null,item.tianyuanid,item.status)}>审核通过</div>
                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </React.Fragment>
                            )
                            : (<div className={styles['no-data']}>暂无数据</div>)
                    }

                </div>


            </div>

        </div>
    </div>
)

export default Detail;
